import { TranslatePipe } from './pipes/translate.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from './services/translate.service';
import { FormatTextTranslatePipe } from './pipes/format-text-translate.pipe';

export function setupTranslateFactory(service: TranslateService) {
  return () => service.use('');
}

@NgModule({
  declarations: [TranslatePipe, FormatTextTranslatePipe],
  imports: [CommonModule],
  exports: [TranslatePipe, FormatTextTranslatePipe],
  providers: [TranslatePipe],
})
export class TranslateModule { }
